import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '..';

AtomBadgeStatut.propTypes = {
  statut: PropTypes.oneOf(['enAttente', 'effectue', 'info', 'neutre', 'erreur']),
  text: PropTypes.string,
  variant: PropTypes.oneOf(['outline', 'filled']),
  icon: PropTypes.string,
  className: PropTypes.string
};

AtomBadgeStatut.defaultProps = {
  statut: 'neutre',
  text: '',
  variant: 'outline',
  icon: null,
  className: null
};

function AtomBadgeStatut({ statut, text, variant, icon, className }) {
  const classNames = [
    'badge-statut',
    `badge-statut-${variant}`,
    `badge-statut-${statut}`,
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames}>
      <span className="badge-statut-puce" aria-hidden="true" />
      {icon && <Icon icon={icon} size="12px" className="badge-statut-icon" />}
      <span className="badge-statut-text">{text}</span>
    </div>
  );
}

export default AtomBadgeStatut;
